import { render, staticRenderFns } from "./deletearea.vue?vue&type=template&id=892ee6b0&scoped=true"
import script from "./deletearea.vue?vue&type=script&lang=js"
export * from "./deletearea.vue?vue&type=script&lang=js"
import style0 from "./deletearea.vue?vue&type=style&index=0&id=892ee6b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892ee6b0",
  null
  
)

export default component.exports